/***************************************************************************************************
 * CRITICAL: Office Add-in History API Polyfill - MUST BE FIRST
 * Office WebView doesn't support History.pushState/replaceState
 * Only apply this polyfill in Office Add-in environment
 */
(function () {
    // Check if we're running in Office Add-in environment
    const isOfficeAddin = typeof window !== 'undefined' && 
                         (window as any).Office !== undefined;
    
    if (isOfficeAddin && typeof window !== 'undefined' && window.history) {
        const safePushState = function (state: any, title: string, url?: string | URL | null) {
            // No-op: Hash routing doesn't need pushState in Office Add-in
        };
        const safeReplaceState = function (state: any, title: string, url?: string | URL | null) {
            // No-op: Hash routing doesn't need replaceState in Office Add-in
        };

        try {
            Object.defineProperty(window.history, 'pushState', {
                value: safePushState,
                writable: true,
                configurable: true
            });
            Object.defineProperty(window.history, 'replaceState', {
                value: safeReplaceState,
                writable: true,
                configurable: true
            });
        } catch (e) {
            // Fallback if Object.defineProperty fails
            (window.history as any).pushState = safePushState;
            (window.history as any).replaceState = safeReplaceState;
        }
    }
})();

/***************************************************************************************************
 * Load `$localize` onto the global scope - used if i18n tags appear in Angular templates.
 */
import '@angular/localize/init';
/**
 * This file includes polyfills needed by Angular and is loaded before the app.
 * You can add your own extra polyfills to this file.
 *
 * This file is divided into 2 sections:
 *   1. Browser polyfills. These are applied before loading ZoneJS and are sorted by browsers.
 *   2. Application imports. Files imported after ZoneJS that should be loaded before your main
 *      file.
 *
 * The current setup is for so-called "evergreen" browsers; the last versions of browsers that
 * automatically update themselves. This includes Safari >= 10, Chrome >= 55 (including Opera),
 * Edge >= 13 on the desktop, and iOS 10 and Chrome on mobile.
 *
 * Learn more in https://angular.io/docs/ts/latest/guide/browser-support.html
 */

/***************************************************************************************************
 * BROWSER POLYFILLS
 */

/** IE9, IE10 and IE11 requires all of the following polyfills. **/
import 'core-js/es/symbol'; // for UT phantomJS
import 'core-js/es/object'; // for UT phantomJS
import 'core-js/es/function'; // for UT phantomJS
// import 'core-js/es6/parse-int';
// import 'core-js/es6/parse-float';
// import 'core-js/es6/number';
// import 'core-js/es6/math';
import 'core-js/es/string'; // for UT phantomJS
// import 'core-js/es6/date';
import 'core-js/es/array'; // for UT phantomJS
// import 'core-js/es6/regexp';
// import 'core-js/es6/map';
// import 'core-js/es6/weak-map';
// import 'core-js/es6/set';

/** IE10 and IE11 requires the following for the Reflect API. */
// import 'core-js/es6/reflect';


/** Evergreen browsers require these. **/
// Used for reflect-metadata in JIT. If you use AOT (and only Angular decorators), you can remove.
import 'core-js/es/reflect';
import 'core-js/es/map';
import 'core-js/es/set';

/**
 * By default, zone.js will patch all possible macroTask and DomEvents
 * user can disable parts of macroTask/DomEvents patch by setting following flags
 */

// (window as any).__Zone_disable_requestAnimationFrame = true; // disable patch requestAnimationFrame
// (window as any).__Zone_disable_on_property = true; // disable patch onProperty such as onclick
// (window as any).__zone_symbol__BLACK_LISTED_EVENTS = ['scroll', 'mousemove']; // disable patch specified eventNames

/*
* in IE/Edge developer tools, the addEventListener will also be wrapped by zone.js
* with the following flag, it will bypass `zone.js` patch for IE/Edge
*/
// (window as any).__Zone_enable_cross_context_check = true;

/***************************************************************************************************
 * Zone JS is required by default for Angular itself.
 */
import 'zone.js'; // Included with Angular CLI.


/***************************************************************************************************
 * APPLICATION IMPORTS
 */
import 'url-search-params-polyfill'; // for Microsoft Edge "urlsearchparams is not defined" error

import * as process from 'process';
window['process'] = process;
